// extracted by mini-css-extract-plugin
export default {"cs-button-solid":"button_cs-button-solid__vl9gD","cta-button":"button_cta-button__PUWRf","link-button":"button_link-button__PqOHB","off-button":"button_off-button__Zt5te"};